import { ChathostRegistrationLabelTypes } from '../typings';

import { CHATHOST_REGISTRATION_LABEL } from '../constants';
import { validateScreenname } from '../validate/screenname-reserve';
import { liveValidatePattern } from '../validate/pattern';
import { liveValidateMaxLength } from '../validate/maxlength';
import { liveValidateMinLength } from '../validate/minlength';
import { liveValidateBlur } from '../validate/blur';
import { liveValidateRequired } from '../validate/required';
import { liveValidateEquals, validateEquals } from '../validate/equals';
import { liveValidateNotEquals, validateNotEquals } from '../validate/notequals';
import { liveValidateSubmit, validateSubmit, autoFocusFirstOnSubmitError } from '../validate/submit';

const validateFormData = (form: HTMLFormElement): boolean => {
    if (form) {
        form.setAttribute('novalidate', 'novalidate');

        const extraInputs: HTMLInputElement[] = [form.studioScreenNameID, form.studioPasswordID];
        const inputs: HTMLInputElement[] = [form.screenName, form.password, form.confirmPassword, form.email, form.confirmEmail, form.termsAccepted, form.residenceCountry];
        const regNav = document.querySelector<HTMLDivElement>('.ch-reg__nav');
        const regNavItems = regNav?.querySelectorAll<HTMLDivElement>('.ch-reg__nav-item');
        const labelTypeContainer = regNav?.querySelector<HTMLInputElement>('input[type=radio]:checked');
        const labelType: ChathostRegistrationLabelTypes = labelTypeContainer?.parentElement?.dataset.label as ChathostRegistrationLabelTypes;

        regNavItems?.forEach((regNavItem: HTMLDivElement) => {
            regNavItem.addEventListener('click', (e: Event) => {
                e.preventDefault();

                const selectedLabelType: ChathostRegistrationLabelTypes | undefined = regNavItem.dataset.label as ChathostRegistrationLabelTypes;
                liveValidateInputFields(selectedLabelType, inputs, extraInputs);
            });
        });

        liveValidateInputFields(labelType, inputs, extraInputs);
        liveValidateSubmit(form);
        liveValidateRequired(form.firstAccID);
        liveValidateRequired(form.residenceCountry);
        liveValidateEquals(form.password, form.confirmPassword);
        liveValidateEquals(form.email, form.confirmEmail);
        liveValidateNotEquals(form.password, form.screenName);

        form.addEventListener('submit', function (this: HTMLFormElement, e: Event) {
            const errors = [...validateSubmit(inputs), validateScreenname(form.screenName), validateEquals(form.password, form.confirmPassword), validateEquals(form.email, form.confirmEmail), validateNotEquals(form.password, form.screenName)];

            const valid = errors.indexOf(false) === -1;

            if (!valid) {
                form.classList.add('focus-visible');
                autoFocusFirstOnSubmitError(this);
                e.preventDefault();

                return false;
            }

            return;
        });
    }

    return false;
};

const liveValidateInputFields = (labelType: ChathostRegistrationLabelTypes, inputs: HTMLInputElement[], extraInputs: HTMLInputElement[]): void => {
    let updatedInputs: HTMLInputElement[];

    if (labelType && (labelType === CHATHOST_REGISTRATION_LABEL.EXISTING_STUDIO || labelType === CHATHOST_REGISTRATION_LABEL.STUDIO)) {
        updatedInputs = [...inputs, ...extraInputs];
    } else {
        updatedInputs = inputs;
    }

    for (const el of updatedInputs) {
        liveValidateMinLength(el);
        liveValidateMaxLength(el);
        liveValidatePattern(el);
        liveValidateBlur(el);
        liveValidateRequired(el);
    }
};

export default validateFormData;
